export default __webpack_public_path__ + "static/media/notfavorite.662091f1.svg";